import { useEffect, useState, useRef } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import styled from "styled-components";
import { NavigationProvider } from "../contexts/NavigationContext";
import VersionTag from "../VersionTag";
import AnalogClock from "./AnalogClock";
import { connectStreamDeckHelper, subscribeHeartbeats, subscribeStreamDeckKeys, updateStreamDeckState } from "./StreamdeckConnection";


// ───────────── Styled Components ─────────────
const StyledMain = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: stretch;
  background-color: var(--color-bg);
`;

const MainContent = styled.main`
  flex-grow: 1;
  background-color: transparent;
  padding: 8rem 4.8rem 6.4rem;
`;

const VersionContainer = styled.footer`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 10;
  margin-bottom: 1rem;
  margin-right: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const Clock = styled.div`
  font-family: monospace;
  font-size: 1.2rem;
  color: var(--color-text-light, #ccc);

  padding: 0.4rem 0.8rem;
  border-radius: 6px;
`;


const HeartbeatIcon = styled.div`
  font-size: 1.4rem;
  opacity: ${(props) => (props.active ? 1 : 0)};
  transition: opacity 0.3s ease;
  z-index: 201;
`;




// ───────────── AppLayout Component ─────────────
function AppLayout() {
  console.log("[AppLayout] Rendered");
  const location = useLocation(); //✅ Stream deck functionality
  const [outletKey, setOutletKey] = useState(Date.now());
  const [heartbeatVisible, setHeartbeatVisible] = useState(false);
  const lastInteractionRef = useRef(Date.now());
  const lastRefreshRef = useRef(Date.now());
  const navigate = useNavigate();

  // ✅ Update window title for Stream Deck detection
  useEffect(() => {
    const path = location.pathname.replace("/", "") || "home";
    document.title = `WiMule – ${path}`;
    console.log(`[AppLayout] Title set to: WiMule – ${path}`);
  }, [location.pathname]);

  
useEffect(() => {
  const unsubscribe = subscribeHeartbeats(() => {
    setHeartbeatVisible(true);

    setTimeout(() => {
      setHeartbeatVisible(false);
    }, 1000);

    const now = Date.now();

    const idleMinutes = (now - lastInteractionRef.current) / 60000;

    if (idleMinutes > 5 && now - lastRefreshRef.current > 3600000) {
      console.log("[Heartbeat] Refreshing outlet");

      setOutletKey(Date.now());
      lastRefreshRef.current = now;
    }
  });

  return unsubscribe;
}, []);





  return (
    <StyledMain>
      <NavigationProvider>
        <Header />
        <MainContent>
          <Outlet key={outletKey} />
        </MainContent>
      </NavigationProvider>
      <VersionContainer>
        <AnalogClock />
        {/* <LiveClock /> */}
        <HeartbeatIcon active={heartbeatVisible}>❤️</HeartbeatIcon>
        <VersionTag />
      </VersionContainer>
    </StyledMain>
  );
}

export default AppLayout;
